import { render, staticRenderFns } from "./AddTaxPage.vue?vue&type=template&id=54920f15"
import script from "./AddTaxPage.vue?vue&type=script&lang=js"
export * from "./AddTaxPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports